import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Moon, Sun } from "lucide-react";
import { useLanguage } from "@/hooks/useLanguage";
import { useTheme } from "@/lib/ThemeContext";

export function Footer() {
  const { t } = useTranslation();
  const { currentLanguage, changeLanguage } = useLanguage();
  const { isDark, toggleTheme } = useTheme();

  return (
    <footer className="bg-brand shadow-sm m-2 rounded-3xl">
      <div className="w-full p-4 flex flex-col sm:flex-row items-center justify-center gap-3">
        <span className="text-sm text-white">
          <Link to="/" className="hover:underline">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </Link>
        </span>
        <div className="flex items-center gap-2">
          <div className="flex items-center gap-1 bg-white/20 rounded-full p-1">
            <button
              type="button"
              onClick={() => changeLanguage("es")}
              className={`px-3 py-0.5 text-xs font-semibold rounded-full transition-colors duration-200 cursor-pointer ${
                currentLanguage === "es" ? "bg-white text-brand dark:bg-app-control dark:text-white" : "text-white/70 hover:text-white"
              }`}
            >
              ES
            </button>
            <button
              type="button"
              onClick={() => changeLanguage("en")}
              className={`px-3 py-0.5 text-xs font-semibold rounded-full transition-colors duration-200 cursor-pointer ${
                currentLanguage === "en" ? "bg-white text-brand dark:bg-app-control dark:text-white" : "text-white/70 hover:text-white"
              }`}
            >
              EN
            </button>
          </div>
          <button
            type="button"
            onClick={toggleTheme}
            role="switch"
            aria-checked={isDark}
            aria-label={isDark ? t("footer.switchToLight") : t("footer.switchToDark")}
            title={isDark ? t("footer.switchToLight") : t("footer.switchToDark")}
            className="relative flex h-8 w-14 items-center rounded-full bg-black/25 p-1 text-white shadow-inner transition-colors duration-200 cursor-pointer focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/80"
          >
            <span
              className={`flex size-6 items-center justify-center rounded-full bg-white text-brand shadow-md transition-transform duration-200 dark:bg-app-control dark:text-white ${
                isDark ? "translate-x-6" : "translate-x-0"
              }`}
            >
              {isDark ? <Moon size={14} aria-hidden="true" /> : <Sun size={14} aria-hidden="true" />}
            </span>
          </button>
        </div>
      </div>
    </footer>
  );
}
